import ProjectsEpicClient from 'bundles/epic/clients/Projects';

/*
 * This file includes utilities to check whether specific features related to Portfolio Projects should be enabled.
 */

/**
 *
 * @returns the result of the epic check
 */
export const shouldEnablePortfolioProjects = () => {
  return ProjectsEpicClient.get('enableV1PortfolioProjects');
};
